// extracted by mini-css-extract-plugin
module.exports = {"underConstruction":"time_underConstruction__184fW"};